import { checkMenuAccess } from "@utils/menu-auth";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AdminModuleTemplate from "./admin-module.template";

const menuUrl = "admin-module";

const AdminModuleComponent = () => {
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const { menuList } = useSelector((state) => state.menu);
  const currentMenu = menuList.find((menu) => menu.menu_url === menuUrl);
  const subMenuPermissions = currentMenu.sub_menu_permissions;
  const history = useHistory();

  // console.log({ menuAccess, currentMenu, subMenuPermissions });

  const handlePermissionClick = (permission) => {
    history.push("/" + permission.menu_url);
  };

  const templateModal = {
    subMenuPermissions,
  };

  const templateEvents = {
    handlePermissionClick,
  };
  return (
    <AdminModuleTemplate
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  );
};

export default AdminModuleComponent;
